export default __webpack_public_path__ + "static/media/decada-0090-0009-min.a9566a53.jpeg";